import { render } from "./Report5.vue?vue&type=template&id=55ddefd2"
import script from "./Report5.vue?vue&type=script&lang=js"
export * from "./Report5.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Vue_Project\\JamoatFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__